"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosGet = void 0;
const nxtp_utils_1 = require("@connext/nxtp-utils");
exports.axiosGet = nxtp_utils_1.axiosGet;
//# sourceMappingURL=mockable.js.map